export const AUTH = {
  REGISTER: 'register',
  LOGIN: 'login',
  NONE: 'none'
} as const;

export type AuthState = typeof AUTH[keyof typeof AUTH];
